module.exports = "/images/pt.svg?3c1befd2cd8b7c8dceff95b622fb180d";